<style scoped lang="less">
.surplus {
    display: flex;
    align-items: center;
    font-size: 18px;
    .surplus-item {
        margin-left: 20px;
    }
}
</style>

<template>
    <el-dialog :visible.sync="show" title="核销录入">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="类型">
                <el-tag effect="dark" size="medium" :type="clacType()">{{model.type}}</el-tag>
            </el-form-item>
            <el-form-item label="姓名" v-if="model.type == '开通新会员'">
                <el-input size="medium" v-model="model.name" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item label="电话" v-if="model.type == '开通新会员'">
                <el-input size="medium" v-model="model.phone" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item label="客户" v-if="model.type != '开通新会员'">
                <el-tag effect="dark" size="medium" style="font-size:20px"
                    type="info">{{model.user.phone}}&nbsp;&nbsp;{{model.user.name}}</el-tag>
            </el-form-item>
            <el-form-item label="猜测年龄" v-if="!(model && model.user && model.user.age)">
                <div>
                    <el-radio-group v-model="age" size="medium">
                        <el-radio-button label="15">未成年</el-radio-button>
                        <el-radio-button label="20">20</el-radio-button>
                        <el-radio-button label="30">30</el-radio-button>
                        <el-radio-button label="40">40</el-radio-button>
                        <el-radio-button label="50">50</el-radio-button>
                        <el-radio-button label="60">60</el-radio-button>
                        <el-radio-button label="70">70</el-radio-button>
                    </el-radio-group>
                </div>
            </el-form-item>
            <el-form-item label="金额">
                <div class="surplus">
                    <el-input-number size="medium" v-model="amount"></el-input-number>
                    <div v-if="model.type != '开通新会员'" class="surplus-item">余额：{{surplus}}</div>
                </div>
            </el-form-item>
            <el-form-item label="备注">
                <el-input size="medium" v-model="model.remarks" style="width:220px"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false">取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { selectUser, selectStore } from "../../util/event.js";
import { HttpClient } from "../../util/http.js";
import { msgError, msgSuccess } from "../../util/toast";
import dayjs from "dayjs";

export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null,
            amount: 1,
            surplus: 0,
            age: "",
        };
    },
    created() { },
    computed: {
        user() {
            if (this.model.user) {
                return this.model.user.phone + " " + this.model.user.name;
            } else {
                return "";
            }
        },
        store() {
            if (this.model.store) {
                return this.model.store.name;
            } else {
                return "";
            }
        },
    },
    methods: {
        clacType() {
            switch (this.model.type) {
                case "充值":
                    return "primary";
                case "消费":
                    return "danger";
                case "开通新会员":
                    return "success";
                default:
                    break;
            }
        },
        async chooseItem(key) {
            if (key == "user") {
                let item = await selectUser();
                this.$set(this.model, key, item);
            } else if (key == "store") {
                let item = await selectStore();
                this.$set(this.model, key, item);
            }
        },
        removeItem(key) {
            this.$set(this.model, key, null);
        },
        addOrEdit(item) {
            this.age = "";
            this.model = null;
            this.loadingSave = false;
            this.show = true;
            this.model = {
                ...item,
            };
            this.amount =
                this.model && this.model.amount
                    ? Math.abs(this.model.amount)
                    : 1;
            this.age = this.model && this.model.user && this.model.user.age
                ? this.model.user.age
                : "";
            this.fetchSurplus();
        },
        async fetchSurplus() {
            if (this.model.type == "开通新会员") return;
            let res = await HttpClient.post("/value/getSurplus", {
                ids: this.model.user._id,
            });
            this.surplus = res[this.model.user._id];
        },
        async save() {
            //开通新会员
            if (this.model.type == "开通新会员") {
                if (!this.model.name) return msgError("请输入名称");
                if (!this.model.phone) return msgError("请输入手机号");
                if (!/^\d{11}$/.test(this.model.phone)) return msgError("请输入11位手机号");
            }
            if (!this.amount) return msgError("金额输入有误");
            if (!this.age) return msgError("猜测一下年龄大概是多少");
            if (this.model && this.model.user && !this.model.user.age && !this.age) return msgError("猜测一下年龄大概是多少");
            if (this.amount == 0) return msgError("金额不能为0");
            if (this.model.type == "消费" && this.amount > this.surplus)
                return msgError("余额不足");

            switch (this.model.type) {
                case "消费":
                    this.model.amount = -Math.abs(this.amount);
                    break;
                case "充值":
                    this.model.amount = Math.abs(this.amount);
                    break;
                case "开通新会员":
                    this.model.amount = Math.abs(this.amount);
                    break;
            }
            this.loadingSave = true;
            let res = await HttpClient.post("/value/add", {
                age: this.age,
                type: this.model.type,
                amount: this.model.amount,
                user:
                    this.model.user && this.model.user._id
                        ? this.model.user._id
                        : null,
                store: this.model.store._id,
                date: this.model.date,
                remarks: this.model.remarks,
                name: this.model.name ? this.model.name : "",
                phone: this.model.phone ? this.model.phone : "",
            });
            if (res == "success") {
                msgSuccess(this.model.type + "成功");
                this.$emit("fetch-data");
                this.show = false;
            }
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        },
    },
};
</script>



        